module.exports = __webpack_public_path__ + "static/img/郭振宇董事长3.c27dc961.png";